module.exports = __webpack_public_path__ + "img/pkg-desc.b6b968a4.svg";